<ng-container *ngIf="customClass;else default">
    <div [class]="'skeleton ' + customClass"></div>
</ng-container>

<ng-template #default>
    <div *ngIf="type === 'circle'" class="skeleton skeleton__circle" [style.width]="width" [style.height]="height"></div>
    <div *ngIf="type === 'rectangle'" class="skeleton skeleton__text" [style.width]="width" [style.height]="height"></div>
    <div *ngIf="type === 'maximum'" class="skeleton skeleton__maximum" [style.width]="width" [style.height]="height"></div>
</ng-template>
